import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { Plus } from 'react-feather';
import BrandInSpaceRow from './BrandInSpaceRow';

const Step3Exclusions = ({ control, errors }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'exclusions.brands',
  });

  const addBrand = () => {
    append({ brand_id: '', name: '', website: '' });
  };

  return (
    <div style={{
      maxWidth: '808px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
        Exclusions
      </h5>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '28px' }}>
        Brands / retailers you don&apos;t want to include. Optionally use a brand ID to auto-fill name and website.
      </p>

      {fields.map((field, index) => (
        <BrandInSpaceRow
          key={field.id}
          control={control}
          errors={errors}
          index={index}
          onRemove={() => remove(index)}
          canRemove={fields.length > 1}
          fieldPrefix="exclusions.brands"
          nameLabel="Name"
          nameRequired={false}
          websiteRequired={false}
          namePlaceholder="Enter brand/retailer name"
        />
      ))}

      <button type="button" onClick={addBrand} style={addBtnStyle}>
        <Plus size={16} />
        Add another
      </button>
    </div>
  );
};

const addBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  background: 'none',
  border: 'none',
  color: '#222',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
  padding: '6px 0',
};

export default Step3Exclusions;
